import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import VerificationGate from './blockingScreen'; // Adjust path if needed
import { useNavigate, Link } from 'react-router-dom';
import './App.css'; // Import the CSS file to apply styles
import { Footer, Header } from "./headerFooter";
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import { getHost } from './config';
import {
  grantAnalyticsConsent,
  setUserIdFromUsername,
  trackLogin,
} from './analytics';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";


const Login = () => {
  // State to handle input values
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showVerification, setShowVerification] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    
    navigate('/', { replace: true });
  }, [navigate]);
  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Call the /login endpoint with the username and password using fetch
      const url = `${getHost()}/api/login`
      console.log(`Attempting to call: ${url}`); // Debugging URL
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password,
        }),
      });

      // Check if the response is OK
      if (!response.ok) {
        throw new Error('Login failed');
      }

      // Extract token from response
      const data = await response.json();
      const token = data.token;
      const refreshToken = data.refresh_token;

      // Save the token in localStorage
      localStorage.setItem('authToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      if (data.needs_terms_acceptance) {
        localStorage.setItem('pendingWelcomeModal', 'true');
        localStorage.removeItem('showWelcomeModal');
      } else {
        localStorage.setItem('showWelcomeModal', 'true');
        localStorage.removeItem('pendingWelcomeModal');
        grantAnalyticsConsent();
      }

      setUserIdFromUsername(username);
      trackLogin('standard');

      // Redirect to another page or update the state to show authenticated content
      const decoded = jwtDecode(token);
      if (decoded?.is_verified === false) {
        setShowVerification(true);
      } else {
        navigate('/main', { replace: true });
}
      // window.location.href = '/dashboard'; // Example: redirect to another page
    } catch (error) {
      // Handle errors (e.g., wrong credentials)
      setError('Λάθος όνομα χρήστη ή κωδικός');
    } 
      finally {
      setLoading(false);
      }
  };

  const isFormValid = username !== '' && password !== '';

  return (
    <div id="root">
        <Header />
          <main className='center-container'>
            <Container className='custom-container p-3'>
              {error && <Alert className='alert-error'>
              {error}
            </Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="loginForm.username">
                  <Form.Label className="custom-label">Όνομα χρήστη</Form.Label>
                  <Form.Control className="custom-form" value={username} onChange={(e) => setUsername(e.target.value.trimEnd())} required/>
                  <Form.Text className="text-muted">
                    <Link to="/forgot-username" className="text-decoration-none forgot-username">
                      Ξέχασα το όνομα χρήστη
                    </Link>
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3" controlId="loginForm.password">
                  <div className="d-flex align-items-center gap-2">
                    <Form.Label className="custom-label">Κωδικός πρόσβασης</Form.Label>
                    <span
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        className="mb-2"
                        onClick={() => setShowPassword(prev => !prev)}
                    >
                        {showPassword ? (
                            <i className="bi bi-eye-slash"></i>
                        ) : (
                            <i className="bi bi-eye"></i>
                        )}
                    </span>
                  </div>
                    <Form.Control 
                      className="custom-form pe-5" 
                      type={showPassword ? "text" : "password"} 
                      value={password} 
                      onChange={(e) => setPassword(e.target.value.trimEnd())} 
                      required
                    />
                    <Form.Text className="text-muted">
                    <Link to="/forgot-password" className="text-decoration-none forgot-password">
                      Ξέχασα τον κωδικό πρόσβασης
                    </Link>
                  </Form.Text>
                </Form.Group>
                <Row>
                <Col>
                  <Button variant="danger" type="submit" disabled={!isFormValid || loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Είσοδος
                      </>
                    ) : (
                      'Είσοδος'
                    )}
                  </Button>
                </Col>
                <Col className="text-end">
                  <Link to="/register">
                    <Button variant="outline-danger">Εγγραφή</Button>
                  </Link>
                </Col>
              </Row>
              <p className="text-muted fst-italic small pt-2 mb-0">
                    Εάν δεν βλέπετε το email επαναφοράς <strong>ονόματος χρήστη</strong> ή <strong>κωδικού πρόσβασης</strong>, παρακαλούμε ελέγξτε τον φάκελο Ανεπιθύμητης Αλληλογραφίας (Spam/Junk). Σε ορισμένες περιπτώσεις, τα μηνύματα μας μπορεί να κατευθυνθούν εκεί λόγω των φίλτρων του email σας.
                </p>
              <p className="text-muted fst-italic small pt-2 mb-0">
                    Για οποιοδήποτε ζήτημα μπορείτε να επικοινωνείτε μαζί μας στο <strong>support@teachers-app.com</strong>.
                </p>
              </Form>
            </Container>
          </main>
        <Footer />
    {showVerification && <VerificationGate forceShow={true} />}
    </div>

  );
};

export default Login;